import React, { useCallback, useEffect, useRef, useState } from 'react';
import SearchForm from 'components/SearchForm';
import { useAuth } from 'hooks/auth';
import TwitterWidget from 'components/Widgets/Twitter';
import GoogleWidget from 'components/Widgets/Google';
import { ExportTrendsModal } from 'components/Widgets/Twitter/ExportTrendsModal';
import { resolveTrendsCountry } from 'utils/locale';
import { Container } from './styles';

const Home: React.FC = () => {
  const { authorizeUser, user } = useAuth();
  const [displayExportTrends, setDisplayExportTrends] = useState(false);
  const [country, setCountry] = useState<string>(() =>
    resolveTrendsCountry(user?.language),
  );
  const userPickedCountry = useRef(false);

  useEffect(() => {
    authorizeUser();
  }, [authorizeUser]);

  useEffect(() => {
    if (userPickedCountry.current) return;
    setCountry(resolveTrendsCountry(user?.language));
  }, [user?.language]);

  const handleSetCountry = useCallback((value: string) => {
    userPickedCountry.current = true;
    setCountry(value);
  }, []);

  return (
    <Container>
      <main>
        <SearchForm />
        {/*<GoogleWidget />*/}
        <TwitterWidget
          displayExportModal={setDisplayExportTrends}
          country={country}
          setCountry={handleSetCountry}
        />
        <ExportTrendsModal
          visible={displayExportTrends}
          dispose={() => setDisplayExportTrends(false)}
          country={country}
        />
      </main>
    </Container>
  );
};

export default Home;
